export const ABSENCE_EVENT_OPTIONS = [
  { seedKey: "annual_leave", labelKey: "people.absenceForm.kindVacation", payable: true },
  { seedKey: "internal_day_off", labelKey: "people.absenceForm.kindDayOff", payable: false },
  {
    seedKey: "unpaid_employer_leave",
    labelKey: "people.absenceForm.kindUnpaidLeave",
    payable: false,
  },
  { seedKey: "part_time", labelKey: "people.absenceForm.kindPartTime", payable: false },
  { seedKey: "sick_leave", labelKey: "people.absenceForm.kindSick", payable: true },
  { seedKey: "no_show", labelKey: "people.absenceForm.kindNoShow", payable: false },
] as const;

export type AbsenceEventSeedKey = (typeof ABSENCE_EVENT_OPTIONS)[number]["seedKey"];
